import LiveChat from "../Components/LiveChat";

const GOOGLE_API_KEY = "AIzaSyCuBrcdrOTCMwCg3q5kK8v4xhFXMivDyUI";

export const LIVE_CHAT_LIMIT =10;


export const YOUTUBE_SEARCH_API = "http://suggestqueries.google.com/complete/search?client=firefox&ds=yt&q=";
export const YOUTUBE_API_URL = "https://youtube.googleapis.com/youtube/v3/videos?part=snippet%2CcontentDetails%2Cstatistics&chart=mostPopular&maxResults=50&regionCode=IN&key= "
+ GOOGLE_API_KEY;